/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bubble_medium'
export default icon
